import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAtomValue, useSetAtom } from 'jotai';
import T from '@wojtekmaj/react-t';

import Button from '@rewardopl/react-ui/button';

import { post } from '@rewardopl/utils/network';

import {
  ButtonWrapper,
  ContentWrapper,
  Footer,
  Heading,
  Intro,
  List,
  ScrollContainer,
  Wrapper,
} from './index.styles';

import Items from './items';

import { likedVendorPlacesState, vendorPlacesQuery } from '../../../../../../store';

import type { PlaceWithDynamicPropertiesForUser } from '@rewardopl/types';

export default function SelectFavoritePlacePage() {
  const navigate = useNavigate();
  const likedPlaces = useAtomValue(likedVendorPlacesState);
  const setPlaces = useSetAtom(
    vendorPlacesQuery({
      includePlacesWithoutLocation: true,
    }),
  );
  const [selectedPlaceId, setSelectedPlaceId] = useState<
    PlaceWithDynamicPropertiesForUser['_id'] | null
  >(null);

  const hasFavoritePlace = Boolean(likedPlaces.length);

  if (hasFavoritePlace) {
    return <Navigate to=".." />;
  }

  async function onAccept() {
    const action = `/api/places/${selectedPlaceId}/like`;

    const response = (await post(action)) as PlaceWithDynamicPropertiesForUser;

    setPlaces((prevPlaces) =>
      prevPlaces.map((place) => (place._id === selectedPlaceId ? response : place)),
    );

    navigate('..');
  }

  return (
    <Wrapper>
      <ScrollContainer>
        <ContentWrapper>
          <Heading>
            <T>Select your sweet store</T>
          </Heading>
          <Intro>
            <T>Unlock a world of treats! Pick your favorite store to get started.</T>
          </Intro>
          <List>
            <Items selectedPlaceId={selectedPlaceId} setSelectedPlaceId={setSelectedPlaceId} />
          </List>
        </ContentWrapper>
      </ScrollContainer>
      <Footer>
        <ButtonWrapper>
          <Button className="primary" disabled={!selectedPlaceId} onClick={onAccept} type="button">
            <T>Confirm</T>
          </Button>
        </ButtonWrapper>
      </Footer>
    </Wrapper>
  );
}
